// extracted by mini-css-extract-plugin
export default {"container":"styles_container__r3Cpi","content":"styles_content__dTpQ0","wrapper":"styles_wrapper__Oa35H"};